<template>
    <div class="page">
        <div class="top-line">
            <div class="top-img">
                <img src="../../assets/img/service_green.png">
            </div>
            <div class="top-text">
                遇到问题了？请在下发填写反馈内容<span>提交</span>至后台客服人员回复解答您的问题。
            </div>
        </div>
        <div class="input-line">
            <p>您的反馈或建议：</p>
            <a-textarea v-model:value="textareaValue" placeholder="请简要描述你在使用产品过程中的问题和意见" allow-clear :rows="6" />
        </div>
        <div class="input-line">
            <p>您的联系信息：</p>
            <a-input v-model:value="name" placeholder="姓名"/>
            <a-input v-model:value="phone" placeholder="联系电话"/>
            <a-button @click="onSubmit">提交</a-button>
        </div>
    </div>
    <pageTool></pageTool>
</template>

<script>
import pageTool from "@/components/nav/pageTool"
import { ref } from 'vue'
import { feedbackReplyApi } from '@/api/feedback'
import {notification} from "ant-design-vue"
export default {
    name: "Feedback",
    setup() {
        const textareaValue = ref('')
        const name = ref('')
        const phone = ref('')
        const onSubmit = async () => {
            const params = {
                creater: name.value,
                msg: name.textareaValue
            }
            const res = await feedbackReplyApi(params)
            if (res) {
                notification.success({ message: '提交成功！', duration: 2.5, description: '' })
                setTimeout(() => {
                    location.reload()
                }, 2000)
            }
        }
        return {
            textareaValue,
            name,
            phone,
            onSubmit
        }
    },
    components: {
        pageTool
    }
}
</script>

<style scoped lang="stylus">
    .page {
        .top-line {
            width 100%
            margin 10px 0
            display flex
            padding 10px
            background #FFF
            .top-img {
                width 40px
                height 40px
            }
            .top-img img {
                width 40px
            }
            .top-text {
                color #949494
                font-size 14px
                padding-left 10px
            }
            .top-text span {
                color #03CA8F
            }
        }
        .input-line {
            width 100%
            margin 10px 0
            padding 10px
            background #FFF
        }
        .input-line p {
            margin-bottom 10px
        }
        .input-line >>> .ant-input-affix-wrapper {
            border-color #D2D2D2
            border-radius 10px
        }
        .input-line >>> .ant-input {
            margin-bottom 5px
            border-radius 5px
        }
        .input-line >>> .ant-btn {
            width 100%
            border-color #44A73D
            background-color #44A73D
            color #FFF
            border-radius 5px
            margin 25px 0
        }
    }
</style>